<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="HALF TITLE">
<p class="halftitle" id="hal1"><span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><b>HERMANN COHEN</b></span></span></p>
<p class="halftitle1"><b>AND THE CRISIS OF LIBERALISM</b></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253039767_Halftitle_1.vue?2f2c8a88